import type videojs from 'video.js'
import './vjs-header.css'

type VideoJs = typeof videojs

let installed = false

export const addHeader = (videojs: VideoJs) => {
  if (installed) {
    return
  }

  installed = true

  const Component = videojs.getComponent('Component')

  class Header extends Component {
    createEl() {
      const root = videojs.dom.createEl(
        'div',
        {
          // Prefixing classes of elements within a player with "vjs-"
          // is a convention used in Video.js.
          className: 'vjs-header',
        },
        {},
        []
      )

      return root
    }
  }

  videojs.registerComponent('Header', Header)
}
